module.exports = __webpack_public_path__ + "img/cn_pocket-15.d9cc0bf.jpg";